import { kycHelpers } from './index';

export const processProductAnswer = async (answer, options = {}) => {
  const {
    adminView,
    investorId,
    alreadyClearedQuestions = {},
    rejectedQuestions,
    product,
    answersIds,
    apiCall
  } = options;

  const { clearAll, prePostCallback, key, ...answerParams } = answer;

  if (prePostCallback) {
    answerParams[key] = await prePostCallback();
  }

  const answerToSend = {
    ...answerParams,
    clearAll: clearAll && !alreadyClearedQuestions[answerParams.questionId]
  };

  if (adminView && investorId) {
    answerToSend.investorId = investorId;
  }

  const res = await apiCall(answerToSend);

  if (clearAll) {
    alreadyClearedQuestions[answerParams.questionId] = true;
  }

  if (rejectedQuestions && res?.data) {
    kycHelpers.getRejectedAnswersIds(
      product,
      answer.questionId,
      answersIds,
      res.data
    );
  }

  return res;
};

